import {
  createContext,
  Dispatch,
  FC,
  ReactNode,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";
import { ThemeEnum, ThemeType } from "./Theme.model";

interface ThemeContextProps {
  theme: ThemeType;
  setCurrentTheme: Dispatch<SetStateAction<ThemeType>>;
}

export const ThemeContext = createContext<ThemeContextProps>({
  theme: localStorage.getItem("theme") || ThemeEnum.LIGHT,
} as ThemeContextProps);

type Props = {
  children?: ReactNode;
};

export const ThemeProvider: FC<Props> = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState<ThemeType>(
    (localStorage.getItem("theme") as ThemeType) || ThemeEnum.LIGHT
  );
  // localStorage.setItem("data-theme-mode", currentTheme || ThemeEnum.LIGHT);
  localStorage.setItem("data-theme-mode", ThemeEnum.LIGHT);
  useEffect(() => {
    document.documentElement.setAttribute("data-theme", currentTheme);
    localStorage.setItem("theme", currentTheme);
  }, [currentTheme]);
  return (
    <ThemeContext.Provider
      value={{
        theme: currentTheme,
        setCurrentTheme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
